<script>
    import { company, companyOptions, toCompanyOption } from './stores.js'
    import Dropdown from './Dropdown.svelte'

    export let onChange = () => false
    export let onCancel = () => false
</script>

<Dropdown   text="Empresa"
            noOption={false}
            options={$companyOptions} 
            selected={toCompanyOption($company)} 
            onChange={onChange}
            onCancel={onCancel} />
